import React, { memo } from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const SPINNER_SIZE = { width: '40px', height: '40px' }

function SearchLoading() {
  return (
    <div className="image-assistant-panel__state">
      <Icon svgComponent={RotatingSpinner} size={SPINNER_SIZE} color="primary" notSpaced />
      <p className="image-assistant-panel__state-title cgt-heading-200">
        Loading search results...
      </p>
    </div>
  )
}

export default memo(SearchLoading)
